import {
  Box,
  Tab,
  Tabs,
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  InputAdornment,
  Container,
} from "@mui/material";
import React, { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";

// import Heading from "../../components/Heading";

// import GlobalBanner from "../../components/GlobalBanner";
// import { BNRS, } from "../../constants/AssetsPath";
// import GlobalSubHeading from "../../components/GlobalSubHeading";
// import { HOMEAPPLIANCEPLANS, MOBILEPLANS } from "../../utils/Json";
import MBLGDTSBNR from "../assets/Banner/WebBanner/MobileGadgets.png";
import HMEAPLNCGDTSBNR from "../assets/Banner/WebBanner/HomeAppliance.png";
import TestimonialCard from "../components/HomeAppliances/TestimonialCard";
import VideoTestimonial from "../components/HomeAppliances/VideoTestimonial";
import StepCard from "../components/HomeAppliances/StepCard";
import PlanCard from "../components/HomeAppliances/PlanCard";
import RatingCard from "../components/HomeAppliances/RatingCard";

// Gadgets Protection
import CLMS from "../assets/icons/Claims.png";
import PCKUP from "../assets/icons/PickUp.png";
import DELVRY from "../assets/icons/Delivery.png";
import PHNREPAIR from "../assets/icons/PhoneRepair.png";
import BLGBCKGRND from "../assets/images/Home/Blog.png";

// import banner1 from "../assets/Banner/WebBanner/b2.png";

// Banner
import TRVLASTNCBNR from "../assets/Banner/WebBanner/TravelAssistance.png";
import AUTOMOTIVEASTNCBNR from "../assets/Banner/WebBanner/AutomotiveAssistance.png";
// import MBLGDTSBNR from "../assets/Banner/WebBanner/MobileGadgets.png";
// import HMEAPLNCGDTSBNR from "../assets/Banner/WebBanner/HomeAppliance.png";
import HMEASTNCBNR from "../assets/Banner/WebBanner/HomeAssistance.png";
import INCMTRTCTBNR from "../assets/Banner/WebBanner/IncomeProtect.png";
import TRVLMDCLBNR from "../assets/Banner/WebBanner/TravelMedical.png";
import CYBRSCRTYBNR from "../assets/Banner/WebBanner/CyberSecurity.png";
import CAREERBANERS from "../assets/Banner/WebBanner/CareerBanner.png";
import BECOMEPARTNER from "../assets/Banner/WebBanner/BecomePartnerBanner.png";
import PRIVACYPOLICY from "../assets/Banner/WebBanner/PrivacyPolicyBanner.png";
import TNC from "../assets/Banner/WebBanner/TnCBanner.png";
import OUTPRODUCTS from "../assets/Banner/WebBanner/OurProducts.png";
import Header from "../layout/Header";
import logo from "../assets/images/About/about-logo.png";
import HeroSection from "../components/HeroSection";
import BannerContent from "../components/BannerContent";
import banner1 from "../assets/Banner/WebBanner/HD phone.png";
import HassleFree from "../components/HomeAppliances/hasslefree";


// import mobile from '../assets/Banner/WebBanner/MobileGadgets.png';
// import mobilee from '../';

const FeatureItem = ({ text }) => (
  <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.6 }}>
    <CheckCircleIcon color="success" sx={{ fontSize: 18 }} />
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{
        textAlign: "left",
        fontFamily: 'Poppins", serif',
        fontSize: { xs: "0.8rem", sm: "0.9rem", md: "0.98rem" },
      }}
    >
      {text}
    </Typography>
  </Stack>
);
const Stat = ({ icon, label, sub }) => (
  <Stack alignItems="center">
    {icon}
    <Typography
      variant="h6"
      fontWeight={700}
      sx={{ fontFamily: '"Poppins", serif' }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{ fontFamily: '"Poppins", serif' }}
    >
      {sub}
    </Typography>
  </Stack>
);

const MobileProtection = () => {
  const [formData, setFormData] = useState({
    brand: "",
    purchaseDate: "",
    amount: "",
  });

  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const HOMEAPPLIANCEPLANS = [
    {
      title: "Damage Protection Plan",
      customers: "Chosen by 90,796 customers in last 30 days",
      features: [
        "Cover cost of future damages due to accidents!",
        "Cover cost due to liquid damages e.g water spills!",
      ],
      image: "/path/to/image1.png", // Replace with actual path
    },
    {
      title: "Extended Warranty ",
      customers: "Chosen by 59,760 customers in last 30 days",
      features: [
        "Professional at-home repairs by certified technicians.",
        "Coverage for electrical and mechanical failures, including components like motors, compressors, and control panels",
      ],
      image: "/path/to/image2.png",
    },
    {
      title: "Annual Maintenance Contract (AMC)",
      customers: "Chosen by 30,760 customers in last 30 days",
      features: [
        "Scheduled preventive maintenance services, such as AC gas refilling, washing machine pump checks, etc.",
        "Timely servicing to prevent unexpected breakdowns.",
      ],
      image: "/path/to/image3.png",
      isNew: true,
    },
  ];

  const MOBILEPLANS = [
    {
      title: "One-Time Screen Replacement",
      customers: "Chosen by 90,796 customers in last 30 days",
      features: [
        "Accidents happen — we've got you covered. If your device screen gets damaged, we'll replace it once at no extra cost.",
        "Available for both new and existing devices.",
        "Available for both new and existing devices.",
      ],
      image: "/path/to/image1.png", // Replace with actual path
    },
    {
      title: "Extended Warranty",
      customers: "Chosen by 59,760 customers in last 30 days",
      features: [
        // "Enjoy peace of mind beyond the standard warranty. We cover your device against all kinds of malfunction issues — from speaker problems to general hardware and software repairs. ",
        "Enjoy peace of mind beyond the standard warranty. We cover your device against all kinds of malfunction issues.",
        "Reliable support whenever you need it. ",
        "Reliable support whenever you need it. ",
      ],
      image: "/path/to/image2.png",
    },
    {
      title: "Accidental & Liquid Damage",
      customers: "Chosen by 30,760 customers in last 30 days",
      features: [
        "Life is unpredictable, but your device protection doesn’t have to be. We cover repair costs for accidental drops and spills. Whether it’s a cracked screen from a fall or damage from liquid.",
        "Full coverage for future mishaps.",
        "Full coverage for future mishaps. Reliable support whenever you need it.",
      ],
      image: "/path/to/image3.png",
      isNew: true,
    },
  ];

  return (
    <>
      <>

      <BannerContent
        bannerImage={banner1}
        title="Gadget Assurance "
        subtitle="Smart protection for your smart devices."
        containerStyles={{ background: "none" }}
        bannerHeight="400px"
        
        
      />

      {/* <HeroSection
        bannerImage={banner1}
        heading="  Protect Your Mobile, Stay Worry-Free"
        description=" Get comprehensive protection plans for your mobile devices.
                Safeguard against accidental damage, liquid spills, and extend
                your device's warranty with our trusted services. Join thousands
                of happy customers who trust us to keep their phones safe and
                running like new!"
        image={logo}
        gradientBg="linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)"
        gradientOpacity={0.9}
      /> */}

      

        <Box>
          <Container maxWidth="lg">
            <Grid
              container
              py={7}
              spacing={4}
              display="flex"
              alignItems="center"
              justifyContent="space-around"
            >
              <Grid item xs={12} md={5} sx={{ width: "450px" }}>
                <Box>
                  {/* <Heading
                                        title={ */}
                  <Typography variant="h4">
                    Trust only the best for Protecting your Appliances
                  </Typography>
                  {/* }
                                    /> */}
                </Box>

                <Stack spacing={0} mt={3}>
                  <FeatureItem text="Professional in-home repairs by expert technicians" />
                  <FeatureItem text="Annual maintenance plans to keep appliances running like new" />
                  <FeatureItem text="100% genuine parts. 0% hidden costs" />
                </Stack>

                <Stack
                  direction="row"
                  spacing={6}
                  mt={4}
                  sx={{ padding: "0px 5px" }}
                >
                  <Stat
                    icon={<EmojiEventsIcon color="primary" />}
                    label="10 years"
                    sub="of expertise"
                  />
                  <Stat
                    icon={<EmojiEmotionsIcon color="primary" />}
                    label="5 Million+"
                    sub="Happy Customers"
                  />
                </Stack>
              </Grid>

              <Grid item xs={12} md={7} sx={{ width: "400px" }}>
                <Box
                  sx={{
                    p: 3,
                    boxShadow: 3,
                    borderRadius: 2,
                    backgroundColor: "white",
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight={600}
                    mb={2}
                    textAlign="left"
                    fontFamily='"Poppins", serif'
                  >
                    Find plans for your device
                  </Typography>

                  <Stack spacing={2}>
                    <TextField
                      fullWidth
                      label="Device Brand"
                      variant="outlined"
                      name="brand"
                      value={formData.brand}
                      onChange={handleChange}
                      // sx={GadgetsProtectionStyles.TextFieldStyle}
                    />

                    <TextField
                      fullWidth
                      label="Purchase date"
                      variant="outlined"
                      name="purchaseDate"
                      value={formData.purchaseDate}
                      onChange={handleChange}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <CalendarTodayIcon />
                          </InputAdornment>
                        ),
                      }}
                      // sx={GadgetsProtectionStyles.TextFieldStyle}
                    />

                    <TextField
                      fullWidth
                      label="How much did you purchase it for?"
                      variant="outlined"
                      name="amount"
                      value={formData.amount}
                      onChange={handleChange}
                      // sx={GadgetsProtectionStyles.TextFieldStyle}
                    />

                    <Button
                      variant="contained"
                      size="large"
                      // sx={GadgetsProtectionStyles.FindPlansButton}
                      fullWidth
                    >
                      Find Plans
                    </Button>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
          </Container>

          <Box py={5} textAlign="center" sx={{ bgcolor: "white" }}>
            <Container maxWidth="lg">
              <Box textAlign="center">
                {/* <Heading title={"Let's find you the best plan"} /> */}
                <Typography variant="h4">
                  Let's find you the best plan
                </Typography>
              </Box>

              <Box
                textAlign="center"
                mt={{
                  xs: "0.7rem",
                  sm: "0.7rem",
                  md: "0.7rem",
                  lg: "0.7rem",
                }}
              >
                {/* <GlobalSubHeading subTitle="Quick. Convenient. Best value-for-money protection plan." /> */}
                <Typography variant="h6">
                  Quick. Convenient. Best value-for-money protection plan.
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Grid
                  container
                  spacing={2}
                  py={3}
                  // sx={GadgetsProtectionStyles.GridCentered}
                >
                  {HOMEAPPLIANCEPLANS.map((plan, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <PlanCard {...plan} />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Container>
          </Box>

          {/* <Box textAlign="center" sx={{ py: 4 }}>
            <Box align="center">
              <Typography variant="h4">
                Hassle-free and convenient claim process
              </Typography>
            </Box>

            <Grid
              container
              spacing={4}
              py={2}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={1}
                  title="Claim in Minutes"
                  description="Call or email us — we’ll handle the rest."
                  icon={
                    <img
                      src={CLMS}
                      alt="Step Icon"
                      style={{ width: 100, height: 100, margin: "auto" }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={2}
                  title="Doorstep Pickup"
                  description="Sit back and relax as we pick up the device from your doorstep"
                  icon={
                    <img
                      src={PCKUP}
                      alt="Step Icon"
                      style={{ width: 100, height: 100, margin: "auto" }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={2}
                  title="Pro Repair"
                  description="Certified experts restore your device to perfection.."
                  icon={
                    <img
                      src={PHNREPAIR}
                      alt="Step Icon"
                      style={{ width: 100, height: 100, margin: "auto" }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={3}
                  title="Swift Return"
                  description="Free delivery of your repaired device at your doorstep"
                  icon={
                    <img
                      src={DELVRY}
                      alt="Step Icon"
                      style={{ width: 100, height: 100, margin: "auto" }}
                    />
                  }
                />
              </Grid>
            </Grid>
          </Box> */}
          <HassleFree />

          <Box align="center" py={5} sx={{ bgcolor: "white" }}>
            <Box align="center">
              {/* <Heading title="Everything that we do is designed around you" /> */}
              <Typography variant="h4">
                Everything that we do is designed around you
              </Typography>
            </Box>
            <RatingCard />

            <Grid container spacing={4} py={3}>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <VideoTestimonial />
              </Grid>
            </Grid>

            <Grid mt={1.5} mb={1.5} item xs={12} sm={6} md={4}>
              <Grid
                container
                spacing={4}
                sx={[
                  {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    width: { xs: 335, sm: 335, md: "100%" },
                  },
                ]}
              >
                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    isImg={true}
                    initials={require("../assets/images/User/Manya.png")}
                    name="Manya"
                    rating={5}
                    review="Quick claim, impressive service. Grateful for prompt support!"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    isImg={true}
                    initials={require("../assets/images/User/Shivani.png")}
                    name="Shivani"
                    rating={5}
                    review="Swift claim, excellent service, highly recommended!"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    isImg={true}
                    initials={require("../assets/images/User/Ankur.jpeg")}
                    name="Ankur"
                    rating={5}
                    review="Hassle-free insurance process, professional handling!"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    initials="AK"
                    name="Akash"
                    rating={5}
                    review="Phone restored, very satisfied, highly recommended!"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </>
    </>
  );
};

export default MobileProtection;
